












export default {
    methods: {
        goHome() {
            this.$store.dispatch("hideDrawer");
            this.$router.push("/");
        }
    },
    computed: {
        relacao() {
            return this.$store.getters.relacao;
        },
        cliente() {
            return this.$store.state.cliente;
        },
        condominio() {
            return this.$store.getters.condominio
        }
    }
}

